import React, { useState, useEffect, useRef } from 'react';

type InlineEditCellProps = {
  value?: string;
  onSave?: (newValue: string) => void;
  type?: string;
  placeholderText?: string;
};

const InlineEditCell: React.FC<InlineEditCellProps> = ({
  value = '',
  onSave,
  type = 'text',
  placeholderText = '',
}) => {
  const [editing, setEditing] = useState(false);
  const [inputValue, setInputValue] = useState(value);
  const [hovered, setHovered] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    setInputValue(value ?? '');
  }, [value]);

  useEffect(() => {
    if (editing && inputRef.current) {
      inputRef.current.focus();
    }
  }, [editing]);

  const handleSave = () => {
    if (onSave) onSave(inputValue);
    setEditing(false);
  };

  if (editing) {
    return (
      <input
        ref={inputRef}
        type={type}
        value={inputValue}
        onChange={e => setInputValue(e.target.value)}
        onBlur={handleSave}
        onKeyDown={e => {
          if (e.key === 'Enter') handleSave();
          if (e.key === 'Escape') {
            setEditing(false);
            setInputValue(value ?? '');
          }
        }}
        style={{
          width: '100%',
          minWidth: 80,
          border: '1px solid #ccc',
          borderRadius: 4,
          padding: '2px 6px',
          fontSize: 14,
          alignItems: 'flex-start',
        }}
      />
    );
  }

  return (
    <span
      style={{
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'left',
        justifyContent: 'left',
        minWidth: 80,
        gap: 6,
        color: '#495057',
        position: 'relative',
        width: '100%',
        textAlign: 'left',
      }}
      onClick={() => setEditing(true)}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      title="Haz click para editar"
    >
      {value
        ? value
        : (
          <>
            <span style={{ marginLeft: 6, fontSize: 13, color: '#adb5bd' }}>
              {placeholderText}
            </span>
          </>
        )
      }
      <button
        type="button"
        style={{
          background: hovered ? '#f4f6fa' : 'transparent',
          border: 'none',
          padding: 4,
          borderRadius: 4,
          cursor: 'pointer',
          display: 'inline-flex',
          alignItems: 'center',
          transition: 'background 0.2s',
          marginLeft: 2,
        }}
        onClick={e => {
          e.stopPropagation();
          setEditing(true);
        }}
        tabIndex={-1}
      >
        <i
          className="fas fa-pen"
          style={{
            fontSize: 13,
            color: hovered ? '#5e72e4' : '#adb5bd',
            transition: 'color 0.2s',
          }}
        />
      </button>
    </span>
  );
};

export default InlineEditCell;